export enum TemplateAttributeType {

  STRING = 'STRING',
  NUMBER = 'NUMBER',
  PHOTO = 'PHOTO',
  BOOLEAN = 'BOOLEAN',
  BOOLEAN_MANDATORY = 'BOOLEAN_MANDATORY',
  SELECT = 'SELECT',
  TEXT = 'TEXT',
  LABEL = 'LABEL'

}
